export default __webpack_public_path__ + "static/media/trash-danger.bb7aa0dd.svg";